import React, { useEffect, useRef, useState } from 'react';
import './CursorTrail.css';

function CursorTrail() {
  const [trails, setTrails] = useState([]);
  const trailIdRef = useRef(0);
  const lastPosRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const dx = e.clientX - lastPosRef.current.x;
      const dy = e.clientY - lastPosRef.current.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      // Only create trail particles when mouse moves enough
      if (distance > 8) {
        lastPosRef.current = { x: e.clientX, y: e.clientY };

        const newTrail = {
          id: trailIdRef.current++,
          x: e.clientX,
          y: e.clientY,
          size: 6 + Math.random() * 8,
          hue: Math.random() * 60 + 280, // Purple to cyan range
        };

        setTrails(prev => [...prev.slice(-20), newTrail]);

        // Remove trail after animation
        setTimeout(() => {
          setTrails(prev => prev.filter(t => t.id !== newTrail.id));
        }, 800);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="cursor-trail-container">
      {trails.map(trail => (
        <div
          key={trail.id}
          className="cursor-trail-particle"
          style={{
            left: trail.x,
            top: trail.y,
            width: trail.size,
            height: trail.size,
            '--hue': trail.hue,
          }}
        />
      ))}
    </div>
  );
}

export default CursorTrail;
